// Project images
import amazonChecker from "../../static/projects/amazon-checker.jpg";
import boilerplateGateway from "../../static/projects/boilerplate-gateway.jpg";
import commentAnalyzer from "../../static/projects/comment-analyzer.jpg";
import dgDraft from "../../static/projects/dg-draft.jpg";
import fennecAnimation from "../../static/projects/fennec-animation.jpg";
import kibbeQuiz from "../../static/projects/kibbe-quiz.jpg";
import productionPlanner from "../../static/projects/production-planner.jpg";
import siteBlocker from "../../static/projects/site-blocker.jpg";

// Tech logos
import chartjs from "../../static/logos/chartjs-logo.svg";
import django from "../../static/logos/django-logo.png";
import docker from "../../static/logos/docker-logo.png";
import github from "../../static/logos/github-logo.png";
import gumroad from "../../static/logos/gumroad-logo.png";
import heroku from "../../static/logos/heroku-logo.png";
import html from "../../static/logos/html-logo.png";
import huggingface from "../../static/logos/huggingface-logo.png";
import javascript from "../../static/logos/javascript-logo.png";
import mysql from "../../static/logos/mysql-logo.png";
import nextjs from "../../static/logos/nextjs-logo.png";
import nodejs from "../../static/logos/nodejs-logo.svg";
import openpyxl from "../../static/logos/openpyxl-logo.png";
import postgres from "../../static/logos/postgres-logo.png";
import pyinstaller from "../../static/logos/pyinstaller-logo.png";
import python from "../../static/logos/python-logo.png";
import rails from "../../static/logos/rails-logo.svg";
import react from "../../static/logos/react-logo.png";
import ruby from "../../static/logos/ruby-logo.png";
import typescript from "../../static/logos/typescript-logo.png";
import wordpress from "../../static/logos/wordpress-logo.png";

const imageMap = {
  // Project snapshots
  amazon_checker: amazonChecker,
  boilerplate_gateway: boilerplateGateway,
  comment_analyzer: commentAnalyzer,
  dg_draft: dgDraft,
  kibbe_quiz: kibbeQuiz,
  production_planner: productionPlanner,
  site_blocker: siteBlocker,
  fennec_animation: fennecAnimation,

  // Logos (keys match tag names)
  chartjs,
  django,
  docker,
  github,
  gumroad,
  heroku,
  html,
  huggingface,
  javascript,
  mysql,
  nextjs,
  nodejs,
  openpyxl,
  postgres,
  pyinstaller,
  python,
  rails,
  react,
  ruby,
  typescript,
  wordpress,
};

export default imageMap;
